import { fun_PostAction, fun_GetAction } from "@/api/index";
import { fun_GetKeys } from "../../../../utils/validate";
export default {
  data() {
    return {
      // 判断是否从工作台进入
      workbenchMenu: null,
      // 工作台状态
      workbenchState: true,
      // 列表loading状态
      loading: false,
      // 表单字段
      form: {
        prjName: null, // 项目名称
        constructionNo: null, // 报建编号
        agencyCorpName: null, // 代理机构名称
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "代理机构名称：",
          value: "agencyCorpName",
          placeholder: "请输入",
          clearable: true
        },
      ],
      // 表格按钮
      btnList: [
        {
          name: "添加",
          type: "success",
        },
        {
          name: "修改",
          type: "primary",
        },
        {
          name: "删除",
          type: "danger",
        }
      ],
      // 列表数据
      tableData: [],
      // 列表基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          isShow: true,
          width: "300",
          fixed: true,
          align: "left",
        },
        {
          label: "状态",
          slotName: "state",
          width: "100",
          fixed: true,
          align: "left",
        },
        {
          label: "代理内容",
          prop: "agencyMark",
          width: "400",
        },
        {
          label: "代理机构名称",
          prop: "agencyCorpName",
          width: "300",
          align: "left",
        },
        {
          label: "代理机构社会信用代码",
          prop: "agencyCorpCode",
          width: "220",
          align: "left",
        },
        {
          label: "项目委托单位名称",
          prop: "prjbuildCorpName",
          width: "300",
          align: "left",
        },
        {
          label: "项目委托单位社会信用代码",
          prop: "buildCorpNameCode",
          width: "220",
          align: "left",
        },
      ],
      // 温馨提示
      tipList: [
        /* {
           type: "text",
           text: "（1）“招标代理委托”必须由项目建设方（甲方）进行操作。",
         },
         {
           type: "text",
           text: "（2）甲方进行了招标代理委托后，该招标代理须进行招标代理备案登记。",
         },
         {
           type: "text",
           text: "（3）新增：点击“添加”；修改：勾选对应项目，点击“修改”；删除：勾选对应项目，点击“删除”。"
         },*/
       ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      total: 0,
      // 用户类型
      loginType: sessionStorage.getItem("loginType"),
      // 选中的数组
      multipleSelection: []
    }
  },
  // 模板编译前
  created() {
    // 获取数据
    this.workbenchMenu = sessionStorage.getItem("workbenchMenu") ? sessionStorage.getItem("workbenchMenu") : null;
  },
  // 模板编译完成
  mounted() {
    // 执行获取列表数据方法
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开遮罩
      this.loading = true;
      // 发起请求
      fun_PostAction("/agencyCorpRecords/entrustList", {
        ...this.form,
        ...this.reqPageData
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.tableData = data.records;
          // 总条数
          this.total = data.total;
          // 关闭遮罩层
          this.loading = false;
        } else {
          // 关闭遮罩层
          this.loading = false;
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 数据字典查询
     * @author 滕威
     */
    fun_Search() {
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author shuhua
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 跳转详情页面
          this.$router.push({
            path: "/biddingAgencyEntrustDetail",
            // 操作类型
            query: { controllerFlg: "add" }
          });
          break;
        case "修改":
          // 执行修改的方法
          this.fun_Edit();
          break;
        case "删除":
          // 执行删除的方法
          this.fun_Del();
          break;
      }
    },
    /**
     * 编辑的方法
     */
    fun_Edit() {
      // 有勾选的数据
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 操作标识
          let rtn = false;
          // 遍历
          this.multipleSelection.forEach(e => {
            // 核验状态为已提交
            if (e.state === "tj") {
              // 操作标识
              rtn = true;
              return;
              // 核验状态为核验通过
            } else if (e.state === "tg") {
              // 验证是否已发招标公告
              this.fun_CheckExistRegistration();
              return;
            } else {
              // 跳转详情页面
              this.$router.push({
                path: "/biddingAgencyEntrustDetail",
                // 操作类型
                query: {
                  id: this.multipleSelection[0].id,
                  controllerFlg: "edit"
                }
              });
            }
          });
          // 若选中行中包含已核验通过的数据行，则提示不能删除
          if (rtn) {
            // 错误消息提示
            this.$alert(
              "该项目信息已提交，无法进行删除或修改操作！",
              "warning"
            );
            return;
          }
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 验证是否已发招标公告
     */
    fun_CheckExistRegistration() {
      // 获取keys
      const keys = fun_GetKeys(this.multipleSelection);
      // 发起请求
      fun_GetAction("/tenderRegistration/checkExistRegistration?keys=" + keys).then(res => {
        // 解构res.data
        const { result } = res.data;
        // 操作成功
        if (result) {
          // 消息提示
          this.$alert(
            "该项目已经存在招标登记信息，不能修改!",
            "warning"
          );
        } else {
          // 跳转详情页面
          this.$router.push({
            path: "/biddingAgencyEntrustDetail",
            // 操作类型
            query: { id: this.multipleSelection[0].id, controllerFlg: "edit" }
          });
        }
      });
    },
    /**
     * 删除的方法
     * @author shuhua
     */
    fun_Del() {
      // 有勾选的数据
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 弹出询问confirm
          this.$confirm("是否确定删除选中数据？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 操作标识
            let rtn = false;
            // 操作标识
            let buildCorpRtn = false;
            // 遍历
            this.multipleSelection.forEach(e => {
              // 核验状态为已提交
              if (e.state === "tj") {
                // 操作标识
                rtn = true;
                return;
              }
              // 对比登录身份与项目委托单位是否一致，一致则可以删除，不一致重新选择
              if (e.buildCorpId === "bb120687-492c-4617-9669-e02355db1492") {
                // 操作标识
                buildCorpRtn = true;
                return;
              }
            });
            // 若选中行中包含已核验通过的数据行，则提示不能删除
            if (rtn) {
              // 错误消息提示
              this.$alert(
                "该项目信息已提交，无法进行删除或修改操作！",
                "warning"
              );
              return;
            }
            // 选中行包含非项目委托单位数据，无法删除，需重新选择
            if (buildCorpRtn) {
              // 错误消息提示
              this.$alert(
                "选中数据中的项目委托单位与登录身份不一致，无法删除选中数据！",
                "warning"
              );
              return;
            }
            // 获取keys
            const keys = fun_GetKeys(this.multipleSelection);
            // 发起请求
            fun_GetAction("/agencyCorpRecords/delete?keys=" + keys).then(res => {
              // 解构res.data
              const { result, msg } = res.data;
              // 操作成功
              if (result) {
                // 重新加载列表
                this.fun_GetList();
                // 操作成功
                this.$message.success(msg);
              } else {
                // 错误消息提示
                this.$message.error(msg);
              }
            });
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值
      this.multipleSelection = e;
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * @description 进入详情
     * @author
     */
    fun_Details(e) {
      // 跳转详情页面
      this.$router.push({
        path: "/biddingAgencyEntrustDetail",
        // 操作类型
        query: { id: e.val.id, controllerFlg: "detail" }
      });
    },
  }
}